import { PostHogProvider } from '@posthog/react';
import { posthogKey, posthogOptions } from '@shared/lib/posthog';
import Navbar from '../components/landing/Navbar';
import HeroSection from '../components/landing/HeroSection';
import HowItWorks from '../components/landing/HowItWorks';
import FeaturesSection from '../components/landing/FeaturesSection';
import SecuritySection from '../components/landing/SecuritySection';
import CTASection from '../components/landing/CTASection';
import Footer from '../components/landing/Footer';
import CloudDivider from '../components/landing/CloudDivider';

const C = {
  navy950: '#060b14',
  bone: '#F9F6EE',
};

export default function Landing() {
  return (
    <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
    <div className="min-h-screen" style={{ zoom: 0.78 }}>
      <Navbar />
      <HeroSection />
      <CloudDivider from={C.navy950} to={C.bone} variant={0} />
      <div className="deferred-section">
        <HowItWorks />
      </div>
      <CloudDivider from={C.bone} to={C.navy950} variant={1} />
      <div className="deferred-section">
        <FeaturesSection />
      </div>
      <CloudDivider from={C.navy950} to={C.bone} variant={2} />
      <div className="deferred-section">
        <SecuritySection />
      </div>
      <CloudDivider from={C.bone} to={C.navy950} variant={0} short />
      <div className="deferred-section">
        <CTASection />
      </div>
      <div className="deferred-section">
        <Footer />
      </div>
    </div>
    </PostHogProvider>
  );
}
